/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';

import {EmployeeIdPipe} from './employee-id.pipe';
import {EmployeePhotoUriPipe} from './employee-photo-uri.pipe';
import {EntityAvatarComponent} from './entity-avatar.component';
import {GPEmployeeIdComponent} from './gp-employee-id/gp-employee-id.component';
import {CreateAdminUserModalComponent} from './modal/create-admin-user-modal/create-admin-user-modal.component';
import {CreateUserModalComponent} from './modal/create-user-modal/create-user-modal.component';
import {SerieAvatarComponent} from './serie-avatar.component';
import {UserActionListComponent} from './user-action-list/user-action-list.component';
import {UserAvatarComponent} from './user-avatar.component';

import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';
import {NgxSelectModule} from 'ngx-select-ex';
import {SkeletonElementsModule} from 'skeleton-elements/angular';
import {FilesModule} from '../files/files.module';
import {ModalModule} from '../modal/modal.module';
import {MvelModule} from '../mvel/mvel.module';
import {PipesModule} from '../pipes/pipes.module';
import {UiModule} from '../ui/ui.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FilesModule,
    ModalModule,
    TranslateModule,
    PipesModule,
    MvelModule,
    NgxMaskDirective,
    NgxSelectModule,
    UiModule,
    SkeletonElementsModule
  ],
  declarations: [
    UserAvatarComponent,
    EntityAvatarComponent,
    SerieAvatarComponent,
    EmployeeIdPipe,
    EmployeePhotoUriPipe,
    CreateUserModalComponent,
    UserActionListComponent,
    CreateAdminUserModalComponent,
    GPEmployeeIdComponent
  ],
  exports: [
    UserAvatarComponent,
    EntityAvatarComponent,
    EmployeeIdPipe,
    EmployeePhotoUriPipe,
    SerieAvatarComponent,
    CreateUserModalComponent,
    UserActionListComponent,
    GPEmployeeIdComponent
  ],
  providers: [
    provideNgxMask()
  ]
})
export class UserModule {
  public static forRoot(): ModuleWithProviders<UserModule> {
    return {
      ngModule: UserModule
    };
  }
}

export interface SearchOptions {
  search?: string;
  page?: number;
  perPage?: number;
  orderBy?: string;
}
